import { withDefaultErrorHandling } from '@/store/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/api/apiSingleton';

export const getCollectionByShareToken = createAsyncThunk(
  'collection/getCollectionByShareToken',
  withDefaultErrorHandling(async (token: string) => {
    const data = await api.collection.getCollectionByShareToken(token);

    return data.data;
  }),
);
